export default function clearCreatableFields() {
  const elements = document.querySelectorAll('.css-1dimb5e-singleValue');
  elements.forEach((el) => (el.textContent = ''));
}
